/* Kopfrausch, Druckansicht des Perueckenvergleichs. Runde 10, 20.08.2026.
   Baut ein eigenes Druckfenster mit nur der Tabelle, statt die ganze Shopseite
   zu drucken. Damit passt der Vergleich auf eine Seite A4 und behaelt die Bilder.
   Haengt sich selbst an den Druckknopf der Vergleichsansicht, kr-vergleich.js
   bleibt unveraendert. */
(function () {
  'use strict';

  var ZEILEN = [
    ['preis', 'Preis ab'],
    ['haarqualitaet', 'Haarqualität'],
    ['farbe', 'Farbe'],
    ['laenge', 'Länge'],
    ['struktur', 'Haarstruktur'],
    ['groesse', 'Kopfumfang'],
    ['verstellbar', 'Weite verstellbar'],
    ['lace', 'Lace-Front'],
    ['silikon', 'Silikon-Antirutschstellen'],
    ['klebepads', 'Klebepads anbringbar'],
    ['innenleben', 'Innenleben'],
    ['scheitel', 'Scheitelposition']
  ];

  function cssUrl() {
    var sc = document.querySelector('script[src*="kr-vergleich-druck.js"]');
    if (!sc) return '';
    return sc.src.split('?')[0].replace('kr-vergleich-druck.js', 'kr-druck.css');
  }

  function wert(v) {
    if (v == null || v === '') return '<span class="kr-d__nein">keine Angabe</span>';
    if (v === 'Ja') return '<span class="kr-d__ja">Ja</span>';
    if (v === 'Nein') return '<span class="kr-d__nein">Nein</span>';
    return String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;');
  }

  function seite(ps) {
    var d = new Date();
    var datum = ('0' + d.getDate()).slice(-2) + '.' +
                ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear();
    var t = '<thead><tr><th></th>';
    ps.forEach(function (p) {
      t += '<th><img class="kr-d__bild" src="' + p.bild + '" alt="">' +
           p.titel.replace(' - ', '<br>') + '</th>';
    });
    t += '</tr></thead><tbody>';
    var unt = 0;
    ZEILEN.forEach(function (z) {
      var werte = ps.map(function (p) { return String(p[z[0]] == null ? '' : p[z[0]]); });
      var u = false;
      for (var i = 1; i < werte.length; i++) if (werte[i] !== werte[0]) u = true;
      if (u) unt++;
      t += '<tr class="' + (u ? 'kr-d__u' : '') + '"><th>' + z[1] + '</th>';
      ps.forEach(function (p) { t += '<td>' + wert(p[z[0]]) + '</td>'; });
      t += '</tr>';
    });
    t += '</tbody>';
    return '<!DOCTYPE html><html lang="de-CH"><head><meta charset="utf-8">' +
      '<title>Perücken im Vergleich, Kopfrausch</title>' +
      '<link rel="stylesheet" href="' + cssUrl() + '"></head><body>' +
      '<div class="kr-d__kopf"><div><div class="kr-d__marke">Kopfrausch</div>' +
      '<div class="kr-d__tagline">Von Betroffenen für Betroffene</div></div>' +
      '<div class="kr-d__datum">Perücken im Vergleich<br>kopfrausch.ch, ' + datum + '</div></div>' +
      '<h1 class="kr-d__titel">Ihre Auswahl im Vergleich</h1>' +
      '<p class="kr-d__unter">' + ps.length + ' Modelle nebeneinander. ' + unt +
        ' von ' + ZEILEN.length + ' Eigenschaften unterscheiden sich.</p>' +
      '<table>' + t + '</table>' +
      '<div class="kr-d__legende"><span>Hinterlegte Zeilen</span> zeigen, worin sich die Modelle unterscheiden.</div>' +
      '<div class="kr-d__fuss"><div>Kopfrausch GmbH, Waldstatt. AHV- und IV-anerkannt.<br>' +
        'Alle 27 Modelle: kopfrausch.ch/pages/peruecken-vergleich</div>' +
      '<div style="text-align:right">Preise Stand ' + datum + '<br>Änderungen vorbehalten</div></div>' +
      '<' + 'script>window.addEventListener("load",function(){setTimeout(function(){window.print()},600)})<' + '/script>' +
      '</body></html>';
  }

  function drucken() {
    var merk = [];
    try { merk = JSON.parse(window.localStorage.getItem('kr_vergleich') || '[]'); } catch (e) {}
    if (!merk.length) return;
    Promise.all(merk.map(function (h) {
      return fetch('/products/' + h + '?view=vergleich-json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(Boolean);
      if (ps.length < 2) return;
      var w = window.open('', '_blank');
      if (!w) { window.alert('Ihr Browser hat das Druckfenster blockiert. Bitte erlauben Sie Popups für kopfrausch.ch.'); return; }
      w.document.open();
      w.document.write(seite(ps));
      w.document.close();
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = (t && t.closest) ? t.closest('#krVglDruck') : null;
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    drucken();
  }, true);

  /* Schutz fuer den Fall, dass jemand direkt im Browser druckt, statt den Knopf
     zu nutzen. Ohne diese Regel wird die ganze Kategorieseite mitgedruckt. */
  var stil = document.createElement('style');
  stil.textContent =
    '@media print{' +
    'html.kr-vgl-offen body > *:not(.kr-vgl__modal){display:none !important}' +
    'html.kr-vgl-offen .kr-vgl__modal.is-offen{position:static !important;display:block !important;' +
    'background:#fff !important;padding:0 !important;overflow:visible !important}' +
    'html.kr-vgl-offen .kr-vgl__box{box-shadow:none !important;padding:0 !important;max-width:100% !important}' +
    '}';
  (document.head || document.documentElement).appendChild(stil);
})();
